import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=33de1084&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=33de1084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de1084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33de1084')) {
      api.createRecord('33de1084', component.options)
    } else {
      api.reload('33de1084', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=33de1084&scoped=true&", function () {
      api.rerender('33de1084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zO9oznpJNPrG/JS/teamMember.vue"
export default component.exports